import { debounce } from "lodash";
import { Dispatch } from "redux";
import { action as createAction } from "@iva/store-utils/lib/cjs/Types";
import { tableService } from "#services/pilotService";
import { GetState, ThunkResult } from "#store/types";
import { TablecontextActions } from "#store/tablecontext/tableContextTypes";
import { TableContextResponse } from "#/services/pilotService/types";

/**
 * Based on answer in https://stackoverflow.com/a/50494241
 */
export const debouncedSearchFn = debounce(
    (
        candidates: number[],
        dispatch: Dispatch,
        getState: GetState,
        query?: string
    ) => {
        dispatch(createAction(TablecontextActions.START_FETCH, undefined));

        if (candidates.length > 2) {
            tableService(
                getState().environment.SERVICE_URL,
                getState().uiState.rid
            )
                .context(candidates, query)
                .then((response: TableContextResponse) => {
                    dispatch(
                        createAction(
                            TablecontextActions.FETCHED_CONTEXT,
                            response
                        )
                    );
                })
                .catch(error => {
                    console.log(
                        "error while fetching table context",
                        query,
                        candidates,
                        error
                    );
                });
        } else {
            console.log(`Only ${candidates.length} tableIds given`);
        }
    },
    2500
);

export const tableContextActions = (
    candidates: number[],
    query?: string
): ThunkResult => {
    return (dispatch: Dispatch, getState: GetState) => {
        console.log("queued ", candidates);
        dispatch(createAction(TablecontextActions.REQUESTED_FETCH, undefined));
        debouncedSearchFn(candidates, dispatch, getState, query);
    };
};
